const { adminCall } = require("./_utils");

module.exports = {
  create: data => adminCall("repository.create", data),
  modify: data => adminCall("repository.modify", data),
  remove: uid => adminCall("repository.remove", {uid}),
  check: uid => adminCall("repository.check", {uid}),
  getInfo: uid => adminCall("repository.info", {uid})
}
